import { Component, OnInit, AfterViewInit } from "@angular/core";
import { CclNavbarSecondaryService, CclDrawerService } from "certain-common-library";
import { SharedService } from "../../../../modules/shared/services/shared.service";
import { SessionService } from "../../../../modules/shared/services/session-service";

@Component({
    selector: "app-data-page",
    templateUrl: "./data-page.view.html",
    styleUrls: []
})
export class DataPageView implements AfterViewInit, OnInit {
    catalogLayoutConfig: any = {};
    constructor(
        private navSecondaryService: CclNavbarSecondaryService,
        private drawerService: CclDrawerService,
        public sharedService: SharedService,
        private sessionService: SessionService
    ) {
        this.navSecondaryService.sectionLabel = "Data";
    }

    ngAfterViewInit(): void {}

    ngOnInit() {
        this.catalogLayoutConfig = JSON.parse(this.sharedService.setup.layoutConfig);
        if (this.catalogLayoutConfig.listType == "magazine") {
            this.sharedService.catalogNavigateHelper("admin", "catalog/data/highlighted");
        } else if (this.catalogLayoutConfig.listType == "promoted") {
            this.sharedService.catalogNavigateHelper("admin", "catalog/data/promoted");
        } else {
            this.sharedService.catalogNavigateHelper("admin", "catalog/data/general");
        }
        this.navSecondaryService.sectionLabel = "Data";

        this.sessionService.getSessionTracks().then((data) => {
            if (data.body != null) {
                this.sharedService.tracks = data.body["data"];
            }
        });

        this.sessionService.getSessiontags().subscribe((data) => {
            if (data.body != null) {
                this.sharedService.tags = data.body["page"].content;
            }
        });

        this.sessionService.getSessionLevels(this.sharedService.event.id).subscribe((data) => {
            if (data.body != null) {
                this.sharedService.levels = data.body;
            }
        });

        this.sessionService.getSessionTypes(this.sharedService.event.id).then((data) => {
            if (data.body != null) {
                this.sharedService.types = data.body;
            }
        });

        this.sessionService.getAttendeeTypes().subscribe((data) => {
            if (data.body != null) {
                this.sharedService.attendeeTypes = data.body["data"];
            }
        });
    }

    clickEdit(item) {
        this.drawerService.toggleDrawer("small");
        let url = "config-drawer/filter-config";
        this.sharedService.navigateToOutlet("drawer", url);
    }
}
